// NPM
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NO_RESULTS_TEXT = {
  default: {
    heading: 'No results',
    text: (
      <React.Fragment>
        <p>
          You have the ability to filter out possible recommendations from your
          results. At the moment, all possible recommendations have been
          filtered out.
        </p>
        <p>
          You can still explore every program in Canada. To see every program
          and your match score, go to your{' '}
          <Link to="/results/hidden">Hidden</Link> results.
        </p>
        <p>
          For the programs, locations, or program categories that appeal to you,
          return them to your results by selecting "Unhide."
        </p>
      </React.Fragment>
    ),
  },
  hidden: {
    heading: 'No hidden results',
    text: (
      <React.Fragment>
        <p>
          Once you hide some recommendations, you'll be able to find them again
          here.
        </p>
        <p>
          You can hide categories, subcategories, schools, and cities from the
          Results Summary. You can also hide individual recommendations from
          thelist.
        </p>
      </React.Fragment>
    ),
  },
  favorite: {
    heading: 'No favourite results',
    text: (
      <p>
        Once you favourite some recommendations from the results list, you'll be
        able to find them again here.
      </p>
    ),
  },
};

class EmptyRecommendationList extends PureComponent {
  render() {
    const noResultsText = NO_RESULTS_TEXT[this.props.noResultsText];
    const { areResultsOwnedByUser } = this.props;
    return (
      <div className="EmptyRecommendationsList">
        <h2>{noResultsText.heading}</h2>
        {areResultsOwnedByUser && noResultsText.text}
      </div>
    );
  }
}

EmptyRecommendationList.propTypes = {
  noResultsText: PropTypes.oneOf(['default', 'hidden', 'favorite']).isRequired,
};

export default EmptyRecommendationList;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/EmptyRecommendationList.js